import { useEffect, useState } from "react";
import { fetchRangeUserTypes, fetchUsersByUserTypeID, fetchUserTypes, getExistingSubscriptionChargesByID, getExistingSubscriptionChargesBySubID, getRangeUserAll } from "../api/matAPI";
import AddRangeSubscriptionModal from "./addRangeSubscriptionModa";
import {getSubscriptionChargesByDateAndSubID, getSubscriptionMasterByMembershipType } from "../api/paymentAPI";

const RangeSubscription = (props) => {
    const [rangeUsers,            setRangeUsers]            = useState(null);
    const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
    const [userTypes,             setUserTypes]             = useState([]);
    const [userList,              setUserList]              = useState([]);
    const [subscriptionMaster,    setSubscriptionMaster]    = useState([]);
    const [subscriptionDetails,   setSubscriptionDetails]   = useState({});
    const [isInit,                setIsinit]                = useState(true);
    const [selectedRow,           setSelectedRow]           = useState(null);
    useEffect(() => {
        props.title("Range Subscription", "range-subscription");
        fetchRangeGuests();
        fetchAllUserTypes();
        fetchRangeSubscriptions();
    }, []);

    useEffect(() => {
        if (rangeUsers) {
            fillDataTable();
        }
    }, [rangeUsers]);

    const fetchRangeGuests = async () => {
        try {
            const response = await getRangeUserAll();
            isInit ? setIsinit(false) : $('#tblRangeGuest').KTDatatable().destroy();
            setRangeUsers(response?.rangeUsers);
            return;
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            });
        }
    };

    const fetchAllUserTypes = async () => {
        try {
            const response = await fetchRangeUserTypes();
            const transformedOptions = response?.rangeUserTypes.map(user => ({
                value: user.ID,
                label: user.Name
            }));
            setUserTypes(transformedOptions);
            return;
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            });
        }
    };

    const fetchRangeSubscriptions = async () => {
        try {
            const subscriptionMasters = await getSubscriptionMasterByMembershipType(3);
            const transformedOptions  = subscriptionMasters.map(plan => ({
                value: plan.ID,
                label: plan.Name
            }));
            setSubscriptionMaster(transformedOptions);
            return;
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            });
        }
    };

    const handleShowSubscriptionModal = () => {
        setSelectedRow(null);
        setSubscriptionDetails({});
        setShowSubscriptionModal(true);
    };

    const handleDismissModal = () => {
        setShowSubscriptionModal(false);
    };

    const handleUserTypeChange = async (option) => {
        try {
            const response = await fetchUsersByUserTypeID(option.value);
            const transformedOptions = response?.users.map(user => ({
                value: user.ID,
                label: user.Name,
                categoryID: user.CategoryID,
                subCategoryID: user.SubCategoryID
            }));
            setUserList(transformedOptions);
            return;
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            });    
        }
    };

    const handleSubscriptionChange = async (option) => {
        try {
            const subscriptionID = typeof option === 'object' && option !== null ? option.value : option;
            let response = null;
            if (typeof option === 'object' && option !== null) {
                response = await getSubscriptionChargesByDateAndSubID(option.value);
            } else {
                response = await getExistingSubscriptionChargesByID(option);
            }
            if (Object.keys(response).length > 0 && response?.ID) {
                // when doing add operation setting the state accordingly by replacing commas
                setSubscriptionDetails({ ...response, GSTAmount: response?.GSTAmount?.replace(/,/g, ""), Total: response?.Total?.replace(/,/g, "")});
            } else {
                // all numbers are in INT and SubscriptionCharge is manually set to 0 as it is not maintained and not used in payments
                setSubscriptionDetails({...response, SubscriptionCharge: 0 });
            }
            return;
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            });
        }
    };

    function fillDataTable() {
        const dataTable = $('#tblRangeGuest').KTDatatable({
            data: {
                saveState: false,
                source: rangeUsers,
                pageSize: 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable: true,
            pagination: true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'UserName',
                    title: 'User',
                    width: 200,
                    template: function (row) {
                        if (row.UserType == 'User') {
                            return `<div class="kt-user-card-v2">
                                        <div class="kt-user-card-v2__pic">
                                            ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="user-profile" height="50" width="50" onerror=''>` : ` <div class="kt-badge kt-badge--xl kt-badge--${row.Category === 'Organization' ? 'success' : 'info'} ">  ${row.UserName.substring(0, 1)}</div>`}
                                        </div>
                                        <div class="kt-user-card-v2__details text-clip">
                                            <span class="kt-user-card-v2__name text-clip"> ${row.UserName} </span> <span class="kt-user-card-v2__desc text-clip"> ${row.MembershipNo} </span>
                                        </div>
                                    </div>`;
                        } else {
                            return `<div class="kt-user-card-v2">
                                        <div class="kt-user-card-v2__pic">
                                            ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="event-thumbail" >` : ` <div class="kt-badge kt-badge--xl kt-badge--info">  ${row.UserName.substring(0, 1)}</div>`}
                                        </div>
                                        <div class="kt-user-card-v2__details text-clip">
                                            <span class="kt-user-card-v2__name text-clip"> ${row.UserName} </span>
                                        </div>
                                    </div>`;
                        }
                    }
                },
                {
                    field: 'UserType',
                    title: 'User Type',
                    width: 110
                },
                {
                    field: 'Email',
                    title: 'Email',
                    width: 230
                },
                {
                    field: 'Mobile',
                    title: 'Mobile',
                    width: 130
                },
                {
                    field: 'SubscriptionName',
                    title: 'Subscription Name',
                    width: 220
                }
            ]
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblRangeGuest .kt-datatable__table').addClass('overflow-x-auto');

        dataTable.on('click', 'tr', function () {
            handleShowSubscriptionModal();
            const index = ($("tr").index(this) - 1);
            const data = dataTable.dataSet[index]; // correct data taken
            setSelectedRow(data);
            handleSubscriptionChange(data?.ID);
        });
    }


    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet kt-portlet--mobile">
                        <div className="kt-portlet__head kt-portlet__head--lg padding-l0">
                            <div className="kt-portlet__head-label">
                                <div className="row align-items-center margin-l10">
                                    <div className="col-md-12 kt-margin-b-20-tablet-and-mobile margin-b0">
                                        <div className="kt-input-icon kt-input-icon--left">
                                            <input type="text" className="form-control clientSearch" placeholder="Search Range Guests..." id="generalSearch" />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="kt-portlet__head-toolbar">
                                <div className="kt-portlet__head-wrapper">
                                    <div className="kt-portlet__head-actions">
                                        <button onClick={handleShowSubscriptionModal} type="button" className="btn btn-brand btn-icon-sm text-white d-inline"><i className="la la-plus"></i>Add Range Subscription</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            <div id="tblRangeGuest" className="kt-datatable table-striped clickable"></div>
                        </div>
                    </div>
                </div>
            </div>
            {showSubscriptionModal && (
                <AddRangeSubscriptionModal
                    show={showSubscriptionModal}
                    onDismissModal={handleDismissModal}
                    userTypeOptions={userTypes}
                    onUserTypeChange={handleUserTypeChange}
                    userListOptions={userList}
                    subscriptionMasters={subscriptionMaster}
                    onSubscriptionMasterChange={handleSubscriptionChange}
                    subscriptionDetails={subscriptionDetails}
                    onSuccess={fetchRangeGuests}
                    selectedRow={selectedRow}
                />
            )}
        </>
    );
};

export default RangeSubscription;